var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcObjetivo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.0395 30.2763C35.0888 35.153 30.4761 38.5832 25.099 38.5832C17.9563 38.5832 12.1666 32.5368 12.1666 25.077C12.1666 17.619 14.8836 14.5683 19.1296 7.4165C27.09 11.052 26.8333 24.8332 26.8333 24.8332C26.8333 24.8332 29.7025 16.7005 35.0466 14.1687C36.7608 19.4358 39.0708 25.1907 37.0395 30.2763Z",
    stroke: "url(#paint0_linear_0_18)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_0_18",
    x1: 24.9999,
    y1: 7.4165,
    x2: 24.9999,
    y2: 38.5832,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#285171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0083E9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcObjetivo);
export default __webpack_public_path__ + "static/media/ic_objetivo.3976e950878210732e176ef3567ec9cf.svg";
export { ForwardRef as ReactComponent };